import {Box, Card, CardContent, CardHeader, Typography} from '@mui/material';
import ContextProviderViewFileList from '../../../ViewFileList/Contexts/ContectProviderViewFileList';
import {FileListDetails} from '../../../ViewFileList/FileListDetails';
import Ads from '../../Widgets/Advertisement/Ads';
import UserDetails from './UserDetails';

export default function Startseite() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
        width: '100%',
        maxWidth: 'lg',
        ml: 'auto',
        mr: 'auto',
      }}>
      <Box
        sx={{
          minHeight: 200,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}>
        <UserDetails />
        <ContextProviderViewFileList key={'user_specific'} user_specific={true}>
          <FileListDetails />
        </ContextProviderViewFileList>
      </Box>
      <Box sx={{mt: 4}} component='footer'>
        <Ads />
      </Box>
    </Box>
  );
}
